import { render } from "./CustomerNotesDrawer.vue?vue&type=template&id=2026f098&scoped=true"
import script from "./CustomerNotesDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerNotesDrawer.vue?vue&type=script&lang=js"

import "./CustomerNotesDrawer.vue?vue&type=style&index=0&id=2026f098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2026f098"]])

export default __exports__